import { useState } from 'react';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import api from '../services/api';

/** Sahifa hajmi tanlovlari — ro'yxatning barcha joyida bir xil. */
export const OLCHAM_TANLOV = [10, 25, 50, 100];
/** Standart hajm. 10 — bir ekranga sig'adi va sekin internetda tez keladi. */
export const OLCHAM_DEFAULT = 10;

const LS_PREFIX = 'sata:limit:';

/** Saqlangan tanlovni o'qish. Yaroqsiz qiymat bo'lsa — standart. */
function olchamOqi(key: string, zaxira: number): number {
  try {
    const v = Number(localStorage.getItem(LS_PREFIX + key));
    return OLCHAM_TANLOV.includes(v) ? v : zaxira;
  } catch {
    return zaxira; // localStorage o'chirilgan (shaxsiy oyna) — xato bermaymiz
  }
}

function olchamYoz(key: string, n: number): void {
  try { localStorage.setItem(LS_PREFIX + key, String(n)); } catch { /* muhim emas */ }
}
import type { PagedResp } from '../components/ServerSearchSelect';

/**
 * Server-side paginatsiyali ro'yxat so'rovi.
 * Sahifa/limit holatini boshqaradi va {items,total,pages} qaytaradi.
 */
export function usePagedQuery<T>(
  key: string,
  endpoint: string,
  params: Record<string, string | undefined> = {},
  /**
   * BOSHLANG'ICH sahifa hajmi. Endi bu QAT'IY emas: foydalanuvchi uni
   * paginatsiya yonidagi tanlovdan o'zgartiradi va tanlovi BRAUZERDA saqlanadi
   * (`localStorage`) — har sahifa ochilganda qaytadan tanlab o'tirmasin.
   */
  limit0 = OLCHAM_DEFAULT,
  enabled = true, // false — so'rov yuborilmaydi (masalan sahifa boshqa rejimда bo'lsa)
  // Query `meta` — global xato-toast bilan ishlash uchun (`lib/queryMeta.ts`).
  // Sahifa xatoni O'ZI ko'rsatsa, `SILENT_ERROR` beriladi va toast takrorlanmaydi.
  meta?: Record<string, unknown>
) {
  const [page, setPage] = useState(1);

  /* Sahifa hajmi — kalit bo'yicha ALOHIDA saqlanadi: o'quvchilar ro'yxatida
     100 ta qulay bo'lishi mumkin, to'lovlar tarixida esa 10. Bitta umumiy
     qiymat ikkalasiga ham noqulay bo'lardi. */
  const [limit, setLimitHolat] = useState(() => olchamOqi(key, limit0));
  const setLimit = (n: number) => {
    setLimitHolat(n);
    olchamYoz(key, n);
    setPage(1); // hajm o'zgarsa eski sahifa raqami ma'nosiz bo'lib qoladi
  };

  // Filtr (params) o'zgarganda sahifani RENDER bosqichidayoq 1 ga qaytaramiz.
  // useEffect emas — shu tufayli (yangi params, eski page) kombinatsiyasi bilan
  // ortiqcha so'rov umuman yuborilmaydi. Call-site'lardagi qo'lda yozilgan
  // setPage(1) chaqiruvlari endi shart emas (qolsa ham zarari yo'q).
  const paramsKey = JSON.stringify(params);
  const [prevParamsKey, setPrevParamsKey] = useState(paramsKey);
  if (paramsKey !== prevParamsKey) {
    setPrevParamsKey(paramsKey);
    if (page !== 1) setPage(1);
  }

  const query = useQuery({
    queryKey: [key, page, limit, params],
    queryFn: async () =>
      (await api.get<PagedResp<T>>(endpoint, { params: { page, limit, ...params } })).data,
    placeholderData: keepPreviousData,
    enabled,
    meta,
  });

  // Filtr o'zgarsa 1-sahifaga qaytish uchun
  const resetPage = () => setPage(1);

  return {
    ...query,
    items: query.data?.items ?? [],
    total: query.data?.total ?? 0,
    pages: query.data?.pages ?? 1,
    page,
    setPage,
    resetPage,
    limit,
    setLimit,
    /** Fon yangilanishi (filtr/sort/sahifa) — eski ma'lumot ko'rinib turadi, ustiga nozik overlay uchun */
    fetching: query.isFetching && !query.isLoading,
  };
}
